import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Utils } from "@react-awesome-query-builder/core";
var moment = Utils.moment;
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    config = props.config,
    valueFormat = props.valueFormat,
    use12Hours = props.use12Hours,
    readonly = props.readonly,
    customProps = props.customProps;
  var onChange = function onChange(e) {
    var value = e.target.value;
    if (value == "") value = undefined;else value = moment(new Date(value)).format(valueFormat);
    setValue(value);
  };
  var dtValue = value;
  if (!value) dtValue = "";else dtValue = moment(value).format("YYYY-MM-DDTHH:mm");
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "datetime-local",
    value: dtValue,
    disabled: readonly,
    onChange: onChange
  }, customProps));
});